//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react"
import { LeadsContext } from "../context/LeadsContext";
import { Trash2, Plus, Upload, Download, Tags } from "lucide-react";



//--------------- EXPORTAÇÃO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
export default function ContainerActions() {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const { isOpenModalCreateLead, setIsOpenModalCreateLead } = useContext(LeadsContext); // Estado que armazena se é para abrir o modal Novo Lead
    const { isOpenModalImport, setIsOpenModalImport } = useContext(LeadsContext); // Estado que armazena se é para abrir o modal Importar Lead
    const { isOpenModalExport, setIsOpenModalExport } = useContext(LeadsContext); // Estado que armazena se é para abrir o modal Exportar Leads
    const { isOpenModalAddTagsBulk, setIsOpenModalAddTagsBulk } = useContext(LeadsContext); // Estado que armazena se é para abrir o modal Adicionar Tags em Massa
    const { isOpenModalRemoveTagsBulk, setIsOpenModalRemoveTagsBulk } = useContext(LeadsContext); // Estado que armazena se é para abrir o modal Remover Tags em Massa
    const { inputRef, setInputRef } = useContext(LeadsContext); // Referência à tag Input
    const { colMap, setColMap } = useContext(LeadsContext); // Estado que armazena o objeto Col mapeado
    const { csvPreview, setCsvPreview } = useContext(LeadsContext); // Estado que armazena a lista Preview do CSV



    //--------------- HANDLE DE UPLOAD DE CSV ---------------//
    const handleCSVUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (evt) => {
            const text = evt.target.result;
            const [headerLine, ...lines] = text.trim().split("\n");
            const headers = headerLine.split(",").map(h => h.trim());

            const preview = lines.slice(0, 5).map(line => {
                const cols = line.split(",");
                return headers.reduce((acc, h, i) => ({ ...acc, [h]: cols[i]?.trim() }), {});
            });

            setCsvPreview(preview);
            const headersLower = headers.map(h => h.toLowerCase());
            setColMap({
                nome: headers.find(h => h.toLowerCase() === "nome") || "",
                telefone: headers.find(h => h.toLowerCase() === "telefone") || "",
                email: headers.find(h => h.toLowerCase() === "email") || "",
                tags: headers.find(h => h.toLowerCase() === "tags") || ""
            });
            setIsOpenModalImport(true);
        };
        reader.readAsText(file);
    };



    //--------------- RETORNO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
    return (
        <>

            {/* DIV DOS BUTTONS DO CABEÇALHO */}
            <div className="flex flex-col sm:flex-row mb-2 gap-4 sm:gap-4">

                {/* BUTTON ADICIONAR LEAD */}
                <button onClick={() => setIsOpenModalCreateLead(true)} className="h-[40px] w-full sm:max-w-[250px] flex items-center gap-1 bg-brand-600 hover:bg-brand-700 text-white px-4 py-2 rounded text-sm">
                    <Plus className="w-4 h-4" /> Adicionar Lead
                </button>

                {/* BUTTON IMPORTAR LEADS */}
                <button onClick={() => setIsOpenModalImport(true)} className="h-[40px] w-full sm:max-w-[250px] flex items-center gap-1 bg-surface-2 hover:bg-surface-3 text-white px-4 py-2 rounded text-sm">
                    <Upload className="w-4 h-4" /> Importar Leads
                </button>

                {/* BUTTONS EXPORTAR LEADS */}
                <input type="file" accept=".csv" ref={inputRef} onChange={handleCSVUpload} className="hidden" />
                <button onClick={() => setIsOpenModalExport(true)} className="h-[40px] w-full sm:max-w-[250px] flex items-center gap-1 bg-surface-2 hover:bg-surface-3 text-white px-4 py-2 rounded text-sm">
                    <Download className="w-4 h-4" /> Exportar Leads
                </button>

                {/* BUTTON ADICIONAR TAGS EM MASSA */}
                <button onClick={() => setIsOpenModalAddTagsBulk(true)} className="h-[40px] w-full sm:max-w-[250px] flex items-center gap-1 bg-surface-2 hover:bg-surface-3 text-white px-4 py-2 rounded text-sm">
                    <Tags className="w-4 h-4" /> Adicionar Tags em Massa
                </button>

                {/* BUTTON REMOVER TAGS EM MASSA */}
                <button onClick={() => setIsOpenModalRemoveTagsBulk(true)} className="h-[40px] w-full sm:max-w-[250px] flex items-center gap-1 bg-surface-2 hover:bg-surface-3 text-white px-4 py-2 rounded text-sm">
                    <Trash2 className="w-4 h-4" /> Remover Tags em Massa
                </button>

            </div>

        </>
    )
}